module.exports = __webpack_public_path__ + "img/wine_holder_frame.ad6bfec.webp";